import { reduxKey } from './constants';
import { isFlagEnabled } from './helpers';
/**
 * Get all flags
 */
export var getFlags = function (state) {
    return state[reduxKey] || {};
};
/**
 * Check if flag is enabled
 */
export var flagEnabled = function (state, flag) {
    return isFlagEnabled(getFlags(state), flag);
};
/**
 * Get all flags
 */
export var getEnabledFlagsList = function (state) {
    var flags = getFlags(state);
    return Object.keys(flags).filter(function (flag) { return !!flags[flag]; });
};
//# sourceMappingURL=selectors.js.map